import { createAction } from 'redux-actions'

const ns = 'loading/'

export const setLoadingJoinGoal = createAction(`${ns}SET_JOIN_GOAL`)
export const setLoadingJoinGoalDone = createAction(`${ns}SET_JOIN_GOAL_DONE`)

// Export loading state actions
export const setLoadingExport = createAction(`${ns}SET_EXPORT_LOADING`)
export const setLoadingExportDone = createAction(`${ns}SET_EXPORT_LOADING_DONE`)
